module.exports = __webpack_public_path__ + "img/more.e4bebc44.png";